<template>
  <div class="user-preview">
    <div id="contents">
      <div class="inner clearfix detail-top">
        <h1
          v-if="companyInfo.name"
          class="mt10 fll hd-type-01 company-name"
          data-test="company-name"
        >
          {{ companyInfo.name }}
        </h1>
        <div class="clearfix" />
        <ul class="mt30 fs13 detail-menu">
          <li class="active">
            募集情報
          </li>
          <a><li>フォトクリップ</li></a>
          <a><li>インタビュー記事</li></a>
        </ul>
        <div class="contents-inner clearfix">
          <section class="mt10">
            <article>
              <job-preview-company-introduction
                v-if="!isLightPlan"
                :catch-copy="companyInfo.catchCopy"
                :text="companyInfo.introText"
                :image="companyInfo.introImage"
              />

              <div class="details clearfix">
                <div class="detail-left -active">
                  <h2 class="fwb">
                    募集中の求人情報
                  </h2>
                </div>
                <div class="detail-right -active">
                  <ul class="list-style-01">
                    <li
                      class="mb10"
                      data-test="recruitment-job-info-text"
                      :style="`background: url(${userCommonImageUrlForPc}/icn_arrow_01.png) no-repeat center left;`"
                    >
                      <a class="recruitment-job-info-text">募集中の求人情報の「職種名」が表示されます。</a>
                    </li>
                  </ul>
                </div>
              </div>

              <job-preview-content-outline
                title="事業内容"
                :value="companyInfo.businessContent"
                data-test="businessContent"
              />

              <job-preview-content-outline
                v-if="companyInfo.established"
                title="設立"
                :value="companyInfo.established"
                data-test="established"
              />

              <job-preview-content-outline
                v-if="companyInfo.capital"
                title="資本金"
                :value="companyInfo.capital"
                data-test="capital"
              />

              <job-preview-content-outline
                v-if="companyInfo.sale"
                title="売上高"
                :value="companyInfo.sale"
                data-test="sale"
              />

              <job-preview-content-outline
                v-if="isShow.employee"
                title="従業員数"
                :value="companyInfo.employeeNumber"
                data-test="employeeNumber"
              >
                <template
                  v-if="companyInfo.averageAge || companyInfo.midCareerPercentage"
                  #sub
                >
                  <job-preview-content-sub
                    v-if="companyInfo.averageAge"
                    title="平均年齢"
                    :value="companyInfo.averageAge"
                    title-class="fwb"
                    data-test="averageAge"
                  />
                  <job-preview-content-sub
                    v-if="companyInfo.midCareerPercentage"
                    title="中途入社者の割合"
                    :value="companyInfo.midCareerPercentage"
                    title-class="fwb"
                    data-test="midCareerPercentage"
                  />
                </template>
              </job-preview-content-outline>

              <job-preview-content-outline
                v-if="isShow.representative"
                title="代表者"
                :value="companyInfo.representative"
                data-test="representative"
              >
                <template
                  v-if="companyInfo.representativeProfile"
                  #sub
                >
                  <job-preview-content-sub
                    title="代表者略歴"
                    :value="companyInfo.representativeProfile"
                    title-class="fwb"
                    data-test="representativeProfile"
                  />
                </template>
              </job-preview-content-outline>

              <job-preview-content-outline
                v-if="companyInfo.note"
                title="備考"
                :value="companyInfo.note"
                data-test="note"
              />

              <job-preview-content-outline
                v-if="companyInfo.hp"
                title="企業HP"
                data-test="hp"
              >
                <job-preview-content>
                  <template #body>
                    <p class="clearfix">
                      <a
                        :href="companyInfo.hp"
                        rel="nofollow"
                        target="blank"
                        data-test="value"
                        v-text="companyInfo.hp"
                      />
                    </p>
                  </template>
                </job-preview-content>
              </job-preview-content-outline>
            </article>

            <job-preview-company-images
              v-if="!isLightPlan"
              :company-info="companyInfo"
            />
          </section>

          <section class="mt20 mb20">
            <div
              v-if="!isLightPlan && report.body"
              class="viewpoints pt25 pb25 plr20"
              data-test="viewpoints"
            >
              <div class="viewpoints-left tc pr25">
                <img
                  class="mb5 viewpoints-img"
                  :src="`${userCommonImageUrlForPc}/viewpoints.png`"
                  alt="viewpoints"
                  data-test="viewpoints-img"
                >
                <h2 class="fs13 fwB">
                  女の転職！<br>取材レポート
                </h2>
              </div>
              <div class="viewpoints-right pl25">
                <span
                  v-if="report.name"
                  class="tl fwB fs13 block-style"
                  data-test="viewpoints-name"
                  v-text="`取材担当${report.name}より`"
                />
                <span
                  class="tl fs13 block-style pega-pre-wrap"
                  data-test="viewpoints-body"
                  v-text="report.body"
                />
              </div>
            </div>
          </section>

          <div
            v-if="isShowEnvironment(environment)"
            class="company-preview"
            data-test="environmentForCompany"
          >
            <section class="mt20 mb20">
              <job-preview-data-for-company :environment="environment" />
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/company/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewCompanyIntroduction from '@/components/atoms/JobPreviewCompanyIntroduction'
import JobPreviewContentOutline from '@/components/atoms/JobPreviewContentOutline'
import JobPreviewContentSub from '@/components/atoms/JobPreviewContentSub'
import JobPreviewContent from '@/components/atoms/JobPreviewContent'
import JobPreviewCompanyImages from '@/components/atoms/JobPreviewCompanyImages'
import JobPreviewDataForCompany from '@/components/molecules/JobPreviewDataForCompany'
export default {
  components: {
    JobPreviewCompanyIntroduction,
    JobPreviewContentOutline,
    JobPreviewContentSub,
    JobPreviewContent,
    JobPreviewCompanyImages,
    JobPreviewDataForCompany
  },
  mixins: [jobPreviewCommon],
  props: {
    isLightPlan: {
      type: Boolean,
      default: false
    },
    companyInfo: {
      type: Object,
      required: true
    },
    report: {
      type: Object,
      required: true
    },
    environment: {
      type: Object,
      required: true
    }
  }
}
</script>
